import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const AgeGateModal = ({ open, onClose, onConfirm, checked, setChecked }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="age-gate-modal">
        <DialogHeader>
          <DialogTitle className="heading-upper text-[#144733]">{t("One quick confirmation")}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#57685e]">{t("Please confirm you are eligible to drive before we lock in your car.")}</p>
        <label className="flex items-start gap-2 text-sm text-[#0F1E17] cursor-pointer">
          <input type="checkbox" className="mt-1" checked={checked} onChange={(e) => setChecked(e.target.checked)} data-testid="age-gate-checkbox" />
          {t("I am above the age of 21 and I am eligible to drive in the UAE")}
        </label>
        <button onClick={onConfirm} disabled={!checked} className="btn-cta rounded w-full py-3 text-xs" data-testid="age-gate-continue-btn">
          {t("Continue to booking")}
        </button>
      </DialogContent>
    </Dialog>
  );
};
